/**
 * Copyright (c) 2025 Astatinn LLC
 * All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying,
 * modification, distribution, or use of this software, via any medium,
 * is strictly prohibited.
 */

import('./bootstrap').catch((err) => console.error(err));
